angular.module 'app'
.controller 'SchoolInformationLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->

  $scope.permission = Storage.get('user_permission')
